import { render, staticRenderFns } from "./Saleorder.vue?vue&type=template&id=46ab245b&scoped=true&"
import script from "./Saleorder.vue?vue&type=script&lang=js&"
export * from "./Saleorder.vue?vue&type=script&lang=js&"
import style0 from "./Saleorder.vue?vue&type=style&index=0&id=46ab245b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab245b",
  null
  
)

export default component.exports